import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { CmsEntities, bindToContent } from 'client/data/models/cms';
import { PageModel } from 'client/data/models/page';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { FAST_CHARGING_LEADERBOARD_CONTENT_PATH } from 'site-modules/editorial/constants/fast-charging-leaderboard';
import { LeaderboardInfographic } from 'site-modules/editorial/components/leaderboard-infographic/leaderboard-infographic';

import './fast-charging-leaderboard.scss';

export function FastChargingLeaderboardUI({ content = null, pathname = null, isWidget = false, isMobile = false }) {
  if (!content) {
    return null;
  }

  return (
    <LeaderboardInfographic
      className="fast-charging-leaderboard bg-blue-100"
      content={content}
      pathname={pathname}
      widgetName="fast-charging-leaderboard"
      customLogo={
        <img
          className="mb-0_5"
          src={getStaticImageUrl('/img/infographics/fast-charging/logos/EV_Charging_Test_Small.png')}
          alt="Edmunds EV Charging Test"
          {...(isMobile ? { width: '100%' } : { height: '80' })}
        />
      }
      bottomLogo={
        <img src={getStaticImageUrl('/img/infographics/fast-charging/logos/P3_Small.png')} alt="with P3" width={75} />
      }
      title="The definitive guide to fast-charging speeds"
      titleColorClassName="text-gray-darker"
      titleClassName="text-center fw-medium mb-2"
      legendClassName="medium"
      barsMap={[null, { label: 'Edmunds tested miles per charging hour', key: 'mph' }]}
      stepValue={200}
      maxValue={1000}
      chartValueMeasure="mi/hr"
      creativeId="fast-charging-leaderboard"
      trackingId="go_to_review"
      isWidget={isWidget}
    />
  );
}

FastChargingLeaderboardUI.propTypes = {
  content: CmsEntities.Content,
  pathname: PropTypes.string,
  isWidget: PropTypes.bool,
  isMobile: PropTypes.bool,
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const FastChargingLeaderboard = connect(mapStateToProps)(
  connectToModel(FastChargingLeaderboardUI, {
    content: bindToContent(FAST_CHARGING_LEADERBOARD_CONTENT_PATH),
    pathname: bindToPath('location.pathname', PageModel),
  })
);
